module.exports = __webpack_public_path__ + "static/img/AvenirLTProHeavy.87bc198.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/quiz-fonts/AvenirLTProHeavy.svg
// module id = y5FR
// module chunks = 1